import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PRIZE_MODAL_IMAGES, usePrizeModals, type PrizeModalKey } from '../demo-prizes';

interface PrizeModalProps {
  prizeKey: PrizeModalKey;
  onClose: () => void;
}

/** Модалка категории приза (`#pmodal` макета) — клик по карточке в блоке «Какие подарки можешь выиграть». */
export function PrizeModal({ prizeKey, onClose }: PrizeModalProps) {
  const { t } = useTranslation('landing');
  const modals = usePrizeModals();
  const data = modals[prizeKey];

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal pmodal show" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pbox" role="dialog" aria-modal="true" aria-labelledby="pmTitle">
        <button className="pmx" aria-label={t('close', { ns: 'common' })} onClick={onClose}>
          ×
        </button>
        <div className="pmimg" style={{ backgroundImage: `url("${PRIZE_MODAL_IMAGES[prizeKey]}")` }} />
        <div className="pmbody">
          <h3 id="pmTitle">{data.title}</h3>
          <div>
            {/* eslint-disable-next-line react/no-danger -- доверенный каталог переводов проекта, не пользовательский ввод */}
            <div dangerouslySetInnerHTML={{ __html: data.descriptionHtml }} />
            {data.groups?.map((g, i) => (
              <div className="pmg" key={i}>
                <h4>{g.heading}</h4>
                {g.description ? <p className="pmgd">{g.description}</p> : <div style={{ height: 8 }} />}
                <ul className="pmlist sm">
                  {g.items.map((item, j) => (
                    <li key={j}>
                      <span>
                        {item.name}
                        {item.note && <small>{item.note}</small>}
                      </span>
                      <b>×{item.qty}</b>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            {data.note && <p className="note">{data.note}</p>}
          </div>
        </div>
        <div className="pmfoot">
          <button className="btn" onClick={onClose}>
            {t('prizes.okBtn')}
          </button>
        </div>
      </div>
    </div>
  );
}
